import {
    chat1,
    chat2,
    chat3,
    chat4,
    chat5,
    chat6,
    chat7,
    chat8,
    chat9,
    chat10,
    chat11,
    bees
} from "../assets/whatsapp";

export const chatsData = [
    {
    pic: chat1,
    contact: "Wednesday",
    msg: "They will regret for this",
    time: "12:15 pm",
    unread: 2,
    },
    {
    pic: chat2,
    contact: "Stu",
    msg: "D&D at the comic store, yooo!",
    time: "11:11 am",
    unread: 4,
    },
    {
    pic: chat3,
    contact: "Kun",
    msg: "Bueno... vamo a jugá?",
    time: "11:04 am",
    unread: null,
    },
    {
    pic: chat4,
    contact: "Alfa",
    msg: "A mi que me importa si no me invitan voy igual.",
    time: "10:58 am",
    unread: null,
    },
    {
    pic: chat5,
    contact: "Barney",
    msg: "Challenge accepted",
    time: "10:50 am",
    unread: 6,
    },
    {
    pic: chat6,
    contact: "Phoebs",
    msg: "Don't you dare invite Wednesday. She is a jerk!",
    time: "10:35 am",
    unread: 2,
    },
    {
    pic: chat7,
    contact: "Monica",
    msg: "No Barney no party!",
    time: "10:18 am",
    unread: null,
    },
    {
    pic: chat8,
    contact: "El Comandante",
    msg: "Imposible, estoy en Miami.",
    time: "09:02 am",
    unread: null,
    },
    {
    pic: chat9,
    contact: "+597 12485683",
    msg: "😓",
    time: "9:47 am",
    unread: 3,
    },
    {
    pic: chat10,
    contact: "Michonne",
    msg: "Tomorrow. Monica's apartment. See u!!",
    time: "yesterday",
    unread: null,
    },
    {
    pic: chat11,
    contact: "Jack",
    msg: "Awesome, thank you!",
    time: "yesterday",
    unread: null,
    },
    {
    pic: chat9,
    contact: "+576 48596669",
    msg: "Share this link with all your contacts!",
    time: "yesterday",
    unread: 2,
    },
];

export const messagesData = [
    {
    msg: "Don't do it",
    time: "10:58 am",
    sent: true,
    },
    {
    msg: "Just ignore them",
    time: "10:58 am",
    sent: true,
    },
    {
    msg: "Do what?",
    time: "11:15 am",
    sent: false,
    },
    {
    msg: "What are you talking about?",
    time: "11:15 am",
    sent: false,
    },
    {
    msg: "I know you... you're mad 'cause they didn't invite you",
    time: "11:28 am",
    sent: true,
    },
    {
    msg: "I don't wanna go anyway. ",
    time: "11:36 am",
    sent: false,
    },
    {
    msg: "Don't make a fool of yourself.",
    time: "11:36 am",
    sent: false,
    },
    {
    msg: "Ok just don't do anything silly",
    time: "11:47 am",
    sent: true,
    },
    {
    msg: "Just stay close of the exit room and you'll be fine.",
    time: "11:50 am",
    sent: false,
    },
    {
    msg: "https://www.youtube.com/watch?v=K3-Oz-sHWZo",
    isLink: true,
    time: "11:55 am",
    sent: false,
    },
    {
    msg: "Think this is my best trick? 🤩",
    time: "11:55 am",
    sent: false,
    },
    {
    img: bees,
    time: "11:56 am",
    sent: false,
    },
    {
        img: chat6,
        time: "11:57 am",
        sent: false,
    },
    {
    msg: "Don't you... Phoebs is alergic!",
    time: "12:35 pm",
    sent: true,
    },
    {
    msg: "I bet she is 😉",
    time: "12:35 pm",
    sent: false,
    },
    {
    msg: "Send my regards",
    time: "1:15 pm",
    sent: false,
    },
];